import { useState, useEffect } from "react";
import { api } from "../lib/api";
import { toast } from "sonner";
import { X, Copy, Ticket } from "lucide-react";

export const PromoBanner = () => {
  const [promo, setPromo] = useState(null);
  const [hidden, setHidden] = useState(true);
  const [top, setTop] = useState(65);

  useEffect(() => {
    api.get("/promo-banner").then((r) => {
      if (r.data.enabled) {
        setPromo(r.data);
        setHidden(sessionStorage.getItem("promo_dismissed") === r.data.code);
      }
    }).catch(() => {});
    const measure = () => {
      const nav = document.querySelector("nav.forge-nav");
      if (nav) setTop(nav.offsetHeight + 8);
    };
    measure();
    if (document.fonts?.ready) document.fonts.ready.then(measure);
    window.addEventListener("resize", measure);
    window.addEventListener("orientationchange", measure);
    return () => { window.removeEventListener("resize", measure); window.removeEventListener("orientationchange", measure); };
  }, []);

  const visible = Boolean(promo) && !hidden;
  useEffect(() => {
    if (!visible) return;
    document.body.style.paddingTop = "46px";
    return () => { document.body.style.paddingTop = ""; };
  }, [visible]);

  if (!visible) return null;

  const copy = () => {
    navigator.clipboard.writeText(promo.code).then(() => toast.success(`Code ${promo.code} copied — paste it at checkout!`));
  };
  const dismiss = () => {
    sessionStorage.setItem("promo_dismissed", promo.code);
    setHidden(true);
  };

  return (
    <div data-testid="promo-banner"
      style={{ position: "fixed", top, left: 0, right: 0, zIndex: 99,
        background: "linear-gradient(90deg, rgba(24,14,8,.96), rgba(38,22,10,.96), rgba(24,14,8,.96))",
        borderTop: "1px solid rgba(255,120,71,.55)", borderBottom: "1px solid rgba(255,120,71,.55)",
        boxShadow: "0 4px 18px rgba(255,120,71,.12)", backdropFilter: "blur(10px)" }}
      className="flex items-center justify-center gap-2 sm:gap-3 px-3 py-1.5 text-xs sm:text-sm">
      <Ticket size={15} style={{ color: "var(--ember)" }} className="shrink-0" />
      <span style={{ color: "var(--gold)" }} className="font-semibold truncate" data-testid="promo-banner-message">
        {promo.message || `Limited offer — ${promo.percent_off}% off with code`}
      </span>
      <button onClick={copy} data-testid="promo-banner-copy"
        className="font-display font-bold flex items-center gap-1.5 px-2.5 py-0.5 rounded border transition-colors hover:bg-[rgba(255,120,71,.15)]"
        style={{ color: "var(--ember)", borderColor: "rgba(255,120,71,.55)", letterSpacing: 1.5 }}
        title="Click to copy">
        {promo.code} <Copy size={12} />
      </button>
      <span className="hidden sm:inline" style={{ color: "var(--muted)" }}>−{promo.percent_off}% at checkout</span>
      <button onClick={dismiss} data-testid="promo-banner-dismiss" aria-label="Dismiss"
        className="absolute right-3 p-1 hover:opacity-80" style={{ color: "var(--muted)" }}>
        <X size={15} />
      </button>
    </div>
  );
};
